var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceHolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#637083",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.923 5.021H2.077M8.458 7.21H5.542m6.416-1.895v5.905a1.24 1.24 0 0 1-1.24 1.24H3.282a1.24 1.24 0 0 1-1.24-1.24V5.314c0-.193.045-.382.132-.555l.851-1.703a.93.93 0 0 1 .832-.514h6.288a.93.93 0 0 1 .832.514l.851 1.703c.087.173.131.362.131.555Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceHolderIcon);
export default __webpack_public_path__ + "static/media/device-holder-icon.3e8887afc33f9bc819f8790b047c40f6.svg";
export { ForwardRef as ReactComponent };